import React from 'react';
import { TextInput } from '../text';
import { EmailInputProps } from './model';

export const EmailInput = React.forwardRef<HTMLInputElement, EmailInputProps>((props, ref) => {
  return <TextInput htmlType="email" placeholder="info@youhelp.ru" ref={ref} {...props} />;
});
